const state = {
    text: null,
    entityId: null,
};

const mutations = {
    setSearchText(state, query) {
        state.text = query;
    },
    setEntityId(state, id) {
        state.entityId = id;
    },
};

export default {
    state,
    mutations,
    actions: {},
    modules: {},
};
